import { TokenRefreshedResponse } from '../models/ApiResponse';

/**
 * Provides methods to interact with authentication tokens.
 */
export abstract class TokenService {

  /**
   * Refreshes the user's token and returns the new set of tokens.
   *
   * @throws InvalidTokenException
   * @throws PasswordResetRequiredException
   * @throws UserNotFoundException
   *
   * @param userUri The URI of the user, to which the token belongs.
   * @param refreshToken The currently valid refresh token
   */
  abstract refreshToken(userUri: string, refreshToken: string): Promise<TokenRefreshedResponse>;
}
